import * as React from 'react'
import type { SVGProps } from 'react'
import { type Ref, forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCopy = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 21 20'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M17.167 5.833a2.5 2.5 0 0 1 2.5 2.5v8.334a2.5 2.5 0 0 1-2.5 2.5H8.833a2.5 2.5 0 0 1-2.5-2.5V8.333a2.5 2.5 0 0 1 2.5-2.5zM8.833 7.5A.833.833 0 0 0 8 8.333v8.334c0 .46.373.833.833.833h8.334c.46 0 .833-.373.833-.833V8.333a.833.833 0 0 0-.833-.833z'
      clipRule='evenodd'
    />
    <path
      fill={props.color}
      d='M12.167.833c1.377 0 2.5 1.123 2.5 2.5a.833.833 0 1 1-1.667 0 .84.84 0 0 0-.833-.833H3.833A.84.84 0 0 0 3 3.333v8.334c0 .456.377.833.833.833a.833.833 0 0 1 0 1.667 2.505 2.505 0 0 1-2.5-2.5V3.333c0-1.377 1.123-2.5 2.5-2.5z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCopy)
export default ForwardRef
